import axios from 'axios';
import React, { createContext, useState, useEffect, useMemo, useCallback } from 'react';
import { isMockModeEnabled } from '../../../../mock/mockMode';

export const AuthContext = createContext();

export const AuthContextProvider = ({ children }) => {
    const [token, setToken] = useState('');
    const [originUrl, setOriginUrl] = useState('');
    const [realToken, setRealToken] = useState('');
    const [eventId, setEventId] = useState('');
    const [isAuthReady, setIsAuthReady] = useState(false);
    const [userData, setUserData] = useState(null);
    const [optionalFields, setOptionalFields] = useState(null);
    const [localTourUUID, setLocalTourUUID] = useState(null);
    const [step, setStep] = useState(null);
    const [isTuk, setIsTuk] = useState(null);
    const [isRetrotourIframe, setIsRetrotourIframe] = useState(false);

    // const [fatherDomain, setFatherDomain] = useState(null);

    useEffect(() => {
        const checkIframeOrigin = () => {
            try {
                // console.log("Origin:", userData);
                // console.log("Origin:2", userData.data.companyName);
                setIsRetrotourIframe(userData.data.companyName === "Retro Tour Madrid");
                setIsTuk(userData.data.companyName === "Tuk Tuk World Tours");
            } catch (error) {
                console.error("Error checking origin:", error);
                setIsRetrotourIframe(false);
                setIsTuk(false);
            }
        };

        checkIframeOrigin();
    }, [userData]);

    const logout = () => {
        setToken('');
    };

    // Cargar token desde localStorage al montar
    useEffect(() => {
        const storedToken = localStorage.getItem('authToken');
        if (storedToken) {
            setToken(storedToken);
        } else if (isMockModeEnabled()) {
            setToken('mock-public-token');
            setOriginUrl(window.location.origin);
        }
        setIsAuthReady(true);
    }, []);

    // Actualizar realToken cuando token cambie
    useEffect(() => {
        if (token) {
            setRealToken(`Bearer ${token}`);
        } else {
            setRealToken(null);
        }
    }, [token]);

    // Crear la instancia de axios cuando realToken y originUrl estén disponibles
    const axiosInstance = useMemo(() => {
        if (!realToken) return null;
        return axios.create({
            baseURL: process.env.REACT_APP_API_BASE_URL
                ? `${process.env.REACT_APP_API_BASE_URL}/api`
                : 'https://back.thestablegame.com/api',
            withCredentials: true,
            headers: {
                'Content-Type': 'application/json',
                'X-Origin-Domain': originUrl,
                'Authorization': realToken,
            },
        });
    }, [realToken, originUrl]);

    // Definir fetchUserData como función memoizada para poder usarla en otros lugares si se necesita
    const fetchUserData = useCallback(async () => {
        try {
            if (!axiosInstance) return;
            const response = await axiosInstance.get('/userDataAPI/get-user-data');
            // console.log("RESPUESTA AQUÍ", response.data);
            setUserData(response.data);
            // console.log("USER DATA", response.data);
        } catch (error) {
            console.error('Error fetching user data:', error);
        }
    }, [axiosInstance]);

    // Definir fetchOptionalFields con useCallback y exponerla en el contexto
    const fetchOptionalFields = useCallback(async () => {
        try {
            if (!axiosInstance) return;
            const response = await axiosInstance.get("/activatableAPI/getUserActivatables");
            // console.log("response", response.data);
            setOptionalFields(response.data.activatable);
            // console.log("optionalFields", response.data.activatable);
        } catch (error) {
            console.error("Error fetching options:", error);
        }
    }, [axiosInstance]);

    // Llamar a fetchUserData automáticamente cuando axiosInstance esté listo
    useEffect(() => {
        if (axiosInstance) {
            fetchUserData();
            fetchOptionalFields();
        }
    }, [axiosInstance, fetchUserData, fetchOptionalFields]);

    return (
        <AuthContext.Provider value={{
            token,
            setToken,
            logout,
            axiosInstance,
            isAuthReady,
            realToken,
            setOriginUrl,
            setEventId,
            eventId,
            userData,
            optionalFields,
            setOptionalFields,
            fetchOptionalFields, // Función disponible en el contexto
            localTourUUID,
            setLocalTourUUID,
            step,
            setStep,
            isTuk,
            isRetrotourIframe
            // fatherDomain,
            // setFatherDomain
        }}>
            {children}
        </AuthContext.Provider>
    );
};
